<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Phone Number Validation Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <m-code-block
                :click_anywhere_to_copy="false"
            >
                {{details}}
            </m-code-block>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        title: {
            type: String,
            default: function() { return 'Technical Details'; }
        },
    },

    data() {
        return {
            dialog: false,
            details: '',
        }
    },

    methods: {

        showDialog(obj)
        {
            this.dialog = true;

            this.details = JSON.stringify(obj, null, 2);
        },

        closeDialog()
        {
            this.dialog = false;
        },

        onClickOk()
        {
            this.closeDialog();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>